export default __webpack_public_path__ + "static/media/search.0f0f6ad2.svg";